import React, { useState, useEffect } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Box,
    Button,
} from "@mui/material";

import UserModal from "../components/UserModal";
import {useAuth} from "../components/TokenHandler";

const UserControl = () => {
    const [users, setUsers] = useState([]);
    const [isUserModalOpen, setUserModalOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null); // Track the currently selected user

    const {
        keycloak: kc,
        authenticated,
        infoMessage,
        setInfoMessage,
        givenName,
        email,
        roles,
    } = useAuth();

    console.log(kc)
    const fetchUsers = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/get-users`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${kc.token}`, // Include the token in the Authorization header
                    "Content-Type": "application/json"
                },
            });
            if (response.ok) {
                const data = await response.json();
                setUsers(data);
            } else {
                console.error("Failed to fetch users:", response.statusText);
            }
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };

    useEffect(() => {
        fetchUsers(); // Fetch users on initial render
    }, []);

    const handleOpenUserModal = (user) => {
        setSelectedUser(user); // Set the selected user
        setUserModalOpen(true); // Open the modal
    };

    const handleCloseUserModal = () => {
        setUserModalOpen(false);
        setSelectedUser(null); // Clear the selected user
    };

    const handleOpenAddUserModal = () => {
        setSelectedUser(null); // Clear any selected user
        setUserModalOpen(true); // Open the modal for adding a new user
    };

    return (
        <>
            <TableContainer component={Paper} sx={{ marginTop: 4, maxWidth: "90%", margin: "auto" }}>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "16px",
                    }}
                >
                    <Typography variant="h6" component="div">
                        User Control
                    </Typography>
                    <Button variant="contained" color="primary" onClick={handleOpenAddUserModal}>
                        Add User
                    </Button>
                </Box>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>First Name</TableCell>
                            <TableCell>Last Name</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>Created On</TableCell>
                            <TableCell>Status</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {users.map((user) => (
                            <TableRow
                                key={user.id}
                                onClick={() => handleOpenUserModal(user)} // Open modal with user data
                                style={{ cursor: "pointer" }} // Add hover effect
                            >
                                <TableCell>{user.first_name}</TableCell>
                                <TableCell>{user.last_name}</TableCell>
                                <TableCell>{user.email}</TableCell>
                                <TableCell>{new Date(user.created_on).toLocaleString()}</TableCell>
                                <TableCell>{user.status ? "Active" : "Suspended"}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* User Modal */}
            <UserModal
                open={isUserModalOpen}
                onClose={handleCloseUserModal}
                user={selectedUser}
                refreshUsers={fetchUsers} // Pass refreshUsers to UserModal
            />
        </>
    );
};

export default UserControl;
